/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Editor_SettingsInputs */

const cs_blog_editor_settings = /** @type {(inputs: Blog_Editor_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nastavení`)
};

const en_blog_editor_settings = /** @type {(inputs: Blog_Editor_SettingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settings`)
};

/**
* | output |
* | --- |
* | "Settings" |
*
* @param {Blog_Editor_SettingsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_editor_settings = /** @type {((inputs?: Blog_Editor_SettingsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Editor_SettingsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_editor_settings(inputs)
	return cs_blog_editor_settings(inputs)
});